// eslint-disable-next-line import/no-unassigned-import
import 'whatwg-fetch';
import React from 'react';

import { createRoot } from 'react-dom/client';
import Root from './Root';
import { getDefaultLogger } from './components/logger/logger';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const log = getDefaultLogger();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!);
root.render(<Root />);
log.info('react component rendered on DOM');

// passing no function does not report webvitals
// either use console.log or sendToAnalytics Function available in reportWebVitals
reportWebVitals();
// reportWebVitals(console.log);
// reportWebVitals(sendToAnalytics);
